import { render } from "./question-bundle-entrepreneur-starting-page.vue?vue&type=template&id=58cbcf06&scoped=true&ts=true"
import script from "./question-bundle-entrepreneur-starting-page.vue?vue&type=script&lang=ts"
export * from "./question-bundle-entrepreneur-starting-page.vue?vue&type=script&lang=ts"

import "./question-bundle-entrepreneur-starting-page.vue?vue&type=style&index=0&id=58cbcf06&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cbcf06"]])

export default __exports__